<div class="breadcrumb-bar">
    <div class="container d-flex align-items-center">
        <a [routerLink]="homeLink" class="breadcrumb-home" title="{{ 'Home' | translate | async }}">{{ 'Home' | translate | async }}</a>
        <ng-container *ngIf="parentTitle">
            <span class="breadcrumb-sep">&gt;</span>
            <a *ngIf="parentLink" [routerLink]="parentLink" class="breadcrumb-home" title="{{ parentTitle | translate | async }}">{{ parentTitle | translate | async }}</a>
            <span *ngIf="!parentLink" class="breadcrumb-current" title="{{ parentTitle | translate | async }}">{{ parentTitle | translate | async }}</span>
        </ng-container>
        <span class="breadcrumb-sep">&gt;</span>
        <span class="breadcrumb-current" title="{{ title | translate | async }}">{{ title | translate | async }}</span>
    </div>
</div>
